import { render, staticRenderFns } from "./EditPropertyLandlord.vue?vue&type=template&id=ab9e7f9a&scoped=true&"
import script from "./EditPropertyLandlord.vue?vue&type=script&lang=js&"
export * from "./EditPropertyLandlord.vue?vue&type=script&lang=js&"
import style0 from "./EditPropertyLandlord.vue?vue&type=style&index=0&id=ab9e7f9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab9e7f9a",
  null
  
)

export default component.exports